import {Component, inject, OnInit} from '@angular/core';
import {DocumentDetailService, TransactionHistoryType, TransactionsComponent} from '|shared';
import {EsslObjectType} from '|api/commons';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'icz-document-detail-history',
  templateUrl: './document-detail-history.component.html',
  styleUrls: ['./document-detail-history.component.scss'],
  imports: [TransactionsComponent, AsyncPipe]
})
export class DocumentDetailHistoryComponent implements OnInit {

  private documentDetailService = inject(DocumentDetailService);

  document$ = this.documentDetailService.object$;

  ngOnInit() {
    this.documentDetailService.showSubmitBar = false;
  }

  protected readonly EsslObjectType = EsslObjectType;
  protected readonly TransactionHistoryType = TransactionHistoryType;

}
